import { render, staticRenderFns } from "./PendingComplaints.vue?vue&type=template&id=66c793a7"
import script from "./PendingComplaints.vue?vue&type=script&lang=js"
export * from "./PendingComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports